import { GeoJSON } from "ol/format";
import { Axis } from "../../linearreference/internal";
export function add_tooltip_to_olcontrol(ol_control_classname, tooltiptext) {
    if (document.getElementsByClassName(ol_control_classname).length > 0) {
        const zoom_in_button = document.getElementsByClassName(ol_control_classname)[0];
        zoom_in_button.title = "";
        const tooltip_element = document.createElement("div");
        tooltip_element.className = "infra3dsdk-tooltip map-control-tooltip";
        tooltip_element.innerHTML = tooltiptext;
        zoom_in_button.appendChild(tooltip_element);
    }
}
export function project_point_on_line(coordinates, line_feature) {
    const format = new GeoJSON({
        featureProjection: "EPSG:4326",
    });
    const selected_feature_geojson = JSON.parse(format.writeFeature(line_feature));
    if (selected_feature_geojson["geometry"]["type"] != "LineString")
        return coordinates;
    const fc = {
        type: "FeatureCollection",
        features: [selected_feature_geojson],
    };
    const fallback_coordinates = selected_feature_geojson.geometry.coordinates[0].slice(0, 2);
    const axis = new Axis(fc, undefined, undefined, undefined, null, 5000);
    const uvw = axis.lrtransformer.xyz2uvw(coordinates[0], coordinates[1], 0);
    if (!uvw)
        return fallback_coordinates;
    if (!uvw.lrcoords)
        return fallback_coordinates;
    const u = uvw.lrcoords[0];
    const xyz = axis.lrtransformer.uvw2xyz(uvw.featureidx, u, 0, 0);
    if (!xyz)
        return fallback_coordinates;
    return xyz.slice(0, 2);
}
//# sourceMappingURL=util.js.map